// client/src/routes/app/fiscal/c168.$obligationId.tsx — SCR-FISC-004 · FISC-007 (04 §7, §8.11).
//
// Keyed by the OBLIGATION, which is what §7's route tree says and what a landlord has in hand;
// the package hangs off a declaration the screen resolves or offers to prepare (D-1276).
//
// Both gates, for the reason `index.tsx` gives (D-1271).

import { createFileRoute, redirect } from '@tanstack/react-router';

import { RequireAnyRole, RequirePermission } from '@/components/layout/route-guards';
import { fiscalVisible } from '@/config/fiscal';
import { C168Screen } from '@/features/fiscal/C168Screen';

export const Route = createFileRoute('/app/fiscal/c168/$obligationId')({
  // Withdrawn from view with the fiscal module (D-2780); see `fiscal/index.tsx`.
  beforeLoad: () => {
    if (!fiscalVisible()) throw redirect({ to: '/app/dashboard' });
  },
  component: C168Route,
});

function C168Route() {
  const { obligationId } = Route.useParams();

  return (
    <RequirePermission permission="Fiscal.Read">
      <RequireAnyRole roles={['owner', 'accountant']}>
        <C168Screen obligationId={obligationId} />
      </RequireAnyRole>
    </RequirePermission>
  );
}
